<div class="banner-slider">
  <div class="banner-wrapper">
    <div *ngFor="let slide of slides; let i = index" class="slide-item" [class.active]="i === currentIndex"
      [ngClass]="slide.bannerClass" [style.backgroundImage]="slide.bgImageUrl ? 'url(' + slide.bgImageUrl + ')' : null">

      <div class="slide-overlay"></div>

      <div class="container h-100 position-relative">
        <div class="row h-100 content-row">
          <div class="col-xl-6 col-lg-7 col-md-9 text-white slide-content">
            <h1 class="display-4 fw-bold mb-3 slide-title">{{ slide.title }}</h1>
            <p class="lead mb-4 slide-subtitle" [innerHTML]="slide.subtitle"></p>
            <p class="lead mb-4 slide-subtitle">{{ slide.discription }}</p>
            @if(!removeButtonsAfterLogin){
            <div class="d-flex gap-3 btn-row">
              <a (click)="buttonAction(slide.buttonAction ? slide.buttonAction : slide)"
                class="btn btn-wow-orange btn-lg py-3">
                {{ slide.buttonText }}
              </a>
              @if(slide.buttonText2){
              <a (click)="buttonAction(slide.buttonAction1)" class="btn transparent-btn btn2 btn-lg py-3">
                {{ slide.buttonText2 }}
              </a>
              }
            </div>
               <p class="lead mt-4 fw-bold slide-subtitle checkout" >{{slide.info}} <a  (click)="buttonAction(slide.buttonAction2)">{{slide.buttonText3}}</a></p>
            <div *ngIf="subDescription" class="mt-20 slide-subtitle sub-desc">
             {{ subDescription }}
            </div>
          }
           </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="slides.length > 1" class="slider-pagination">
    <button *ngFor="let dot of slides; let i = index" (click)="setCurrentSlide(i)" class="dot-btn"
      [class.active]="i === currentIndex" [attr.aria-label]="'Go to slide ' + (i + 1)">
    </button>
  </div>
</div>